// src/pages/Legal/SecurityPage.js
import React from 'react';
import { Container, Typography, Paper, Box, Divider, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Lock, Security, VpnKey, VerifiedUser, CloudDone } from '@mui/icons-material';

const RENGIGS = {
  green: '#2E7D32',
  lightGreen: '#4CAF50',
  lime: '#CDDC39',
  dark: '#1A2A3A',
  light: '#F8FAFC',
  border: '#E1E9F0',
  gradient: 'linear-gradient(135deg, #2E7D32 0%, #4CAF50 40%, #8BC34A 70%, #CDDC39 100%)',
};

const SecurityPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3, border: `1px solid ${RENGIGS.border}` }}>
        <Typography variant="h3" sx={{ fontWeight: 900, color: RENGIGS.dark, mb: 1 }}>
          Security at Rengigs
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Our commitment to protecting your data
        </Typography>
        <Divider sx={{ mb: 4 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
          <Lock sx={{ fontSize: 40, color: RENGIGS.green }} />
          <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green }}>Data Encryption</Typography>
        </Box>
        <Typography variant="body1" paragraph>
          All data transmitted between your browser and our servers is encrypted using TLS 1.2/1.3. Sensitive information (passwords, payment details) is hashed or tokenized before storage.
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, mt: 4 }}>
          <VpnKey sx={{ fontSize: 40, color: RENGIGS.green }} />
          <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green }}>Authentication & Access Control</Typography>
        </Box>
        <Typography variant="body1" paragraph>
          We use JWT (JSON Web Tokens) for secure authentication. Passwords are hashed with bcrypt. Multi‑factor authentication (MFA) is available for enhanced security. Access is strictly role‑based.
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, mt: 4 }}>
          <Security sx={{ fontSize: 40, color: RENGIGS.green }} />
          <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green }}>Infrastructure Security</Typography>
        </Box>
        <Typography variant="body1" paragraph>
          Our platform is hosted on secure cloud providers with firewalls, DDoS protection, and regular vulnerability scans. We follow industry best practices for network isolation and patch management.
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, mt: 4 }}>
          <VerifiedUser sx={{ fontSize: 40, color: RENGIGS.green }} />
          <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green }}>Compliance & Audits</Typography>
        </Box>
        <Typography variant="body1" paragraph>
          Rengigs undergoes regular third‑party security audits and penetration testing. We comply with GDPR, CCPA, and other applicable privacy regulations. Our payment processing partner (Stripe) is PCI DSS Level 1 certified.
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, mt: 4 }}>
          <CloudDone sx={{ fontSize: 40, color: RENGIGS.green }} />
          <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green }}>Incident Response</Typography>
        </Box>
        <Typography variant="body1" paragraph>
          We maintain an incident response plan to quickly address any security breaches. In the unlikely event of a data breach, affected users will be notified in accordance with legal requirements.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2, mt: 4 }}>Reporting Vulnerabilities</Typography>
        <Typography variant="body1" paragraph>
          If you discover a security vulnerability, please report it to security@rengigs.com. We will investigate and respond promptly. We encourage responsible disclosure.
        </Typography>

        <Typography variant="body2" sx={{ mt: 4, color: 'text.secondary' }}>
          Last updated: April 19, 2026
        </Typography>
      </Paper>
    </Container>
  );
};

export default SecurityPage;